import CustomSummary from '../CustomForm/CustomSummary';

export default function Summary() {
  return <CustomSummary />;
}
